module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C190_9"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "C146"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowle#page_vii"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "C146"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_1__The_N#page_1"
    }
  }, [_vm._v("CHAPTER 1. The New Partisan Media Environment")])]), _vm._v(" "), _c('p', {
    staticClass: "C146"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_2__What#page_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 2. What Do Partisan Media Actually Say?")])]), _vm._v(" "), _c('p', {
    staticClass: "C146"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_3__Why_D#page_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 3. Why Do Partisan Media Affect Viewers?")])]), _vm._v(" "), _c('p', {
    staticClass: "C146a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_4__Can_P#page_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4. Can Partisan Media Polarize?")])]), _vm._v(" "), _c('p', {
    staticClass: "C193_10"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Appendix#page_92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")])]), _vm._v(" "), _c('p', {
    staticClass: "C146a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_5__Do_Pa#page_94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5. Do Partisan Media Make Viewers Dislike and Distrust the Opposition?")])]), _vm._v(" "), _c('p', {
    staticClass: "C193_10"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Appendix#page_110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")])]), _vm._v(" "), _c('p', {
    staticClass: "C146a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_6__Parti#page_111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6. Partisan Media’s Electoral Effects")])]), _vm._v(" "), _c('p', {
    staticClass: "C193_10"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Appendix#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")])]), _vm._v(" "), _c('p', {
    staticClass: "C146"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_7__How_P#page_135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7. How Partisan Media Matter for America")])]), _vm._v(" "), _c('p', {
    staticClass: "C146"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Data_App#page_159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Data Appendix")])]), _vm._v(" "), _c('p', {
    staticClass: "C146"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Notes#page_179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "C146"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Referenc#page_191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "C146"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Index#page_211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21f80bc3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 66
// module chunks = 0